import frontend from "@/env/frontend";

const { VITE_ENABLE_TABLEAU: enableTableau } = frontend;

export default {
  enableTableau,
  head: {
    title: "ValueMetrics Correction Comparison Extension",
    meta: [
      {
        name: "description",
        content: "A correction comparison extension for Tableau.",
      },
    ],
  },
};
